import React, { useEffect, useState } from 'react'
import { Paper,  Stack  } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'

import { useDispatch, useSelector } from 'react-redux'
import NoDataFound from '../../common/NoDataFound'

import { useSearchParams } from 'react-router-dom';

import AppbarUI from '../../common/AppbarUI'
import BodyWapperUI from '../../common/BodyWapperUI'
import DrawerUI from '../../common/DrawerUI'
import { userSurveryAttemptAction } from '../../redux/toolkit/users/userSurveyAttempt'

const UserSurveryAttempt = () => {
    const [pageSize, setPageSize] = useState(25);
    const [pageState, setPageState] = useState({ page: 0, pageSize: 25 })

    let dispatch = useDispatch()
    const [searchParams] = useSearchParams()
    const user_id = searchParams.get('user_id')

    const { data } = useSelector(state => state.userSurverAttempt)

    let AppColumns = [
        {
            field: 's_no',
            headerName: 'S. No.',
            filterable: false,
            flex: 1,
            headerClassName: 'super-app-theme--header',
            renderCell: (params) => {
                const { page, pageSize } = pageState;
                const serialNumber = (page * pageSize) +
                    params?.api?.getRowIndex(params.row._id) + 1
                return serialNumber;
            }
        },
        {
            field: 'userId',
            headerName: 'User_id',
            flex: 1,
            minWidth: 300,
            headerClassName: 'super-app-theme--header',
        },

        {
            field: 'appId',
            headerName: 'AppId',
            flex: 1,
            minWidth: 300,
            headerClassName: 'super-app-theme--header',

        },
        {
            field: 'ip',
            headerName: 'IP',
            flex: 1,
            minWidth: 300,
            headerClassName: 'super-app-theme--header',

        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            minWidth: 300,
            headerClassName: 'super-app-theme--header',

        },

        {
            field: 'clicked_on',
            headerName: 'Clicked On',
            flex: 1,
            minWidth: 300,
            headerClassName: 'super-app-theme--header',

        },
    ]

    useEffect(() => {
        dispatch(userSurveryAttemptAction(user_id))
    }, [])


    return (
        <>
            <AppbarUI />
            <DrawerUI />

            <BodyWapperUI>
                <Paper sx={{
                    marginTop:2,
                    bgcolor: '#fff',
                    '& .super-app-theme--header': {
                        bgcolor: '#E7F7FF',
                        color: "#344054",
                        fontFamily: "Gantari",
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "12px",
                        lineHeight: "18px",

                        letterSpacing: "0.08em",
                        textTransform: "uppercase"
                    },

                }} elevation={0}>
                    <DataGrid
                        sx={{
                            border: 0,
                            "& .MuiDataGrid-row:hover": {
                                backgroundColor: "#E7F7FF"
                                // color: "red"
                            }
                        }}
                        // className={classes.root}
                        getRowHeight={({ densityFactor }) => {
                            return 70 * densityFactor;
                        }}
                        autoHeight
                        rows={data}
                        columns={AppColumns}
                        getRowId={(row) => row._id}
                        disableSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                        // pagination
                        rowsPerPageOptions={[25, 50, 75, 100]}
                        disableColumnSelector
                        // loading={listLoading ? <LoadingUI /> : false}
                        onCellClick={(params) => {
                            // setPublisher_id(params?.row?._id)
                        }}
                        components={{
                            NoRowsOverlay: () => <NoDataFound />,
                            // Toolbar: GridToolbar,
                        }}
                        // rowCount={total}
                        // paginationModel={setPageState}
                        // page={pageState.page}
                        // pageSize={pageState.pageSize}
                        paginationMode="server"
                        onPageChange={(newPage) => {
                            // setPageState(old => ({ ...old, page: newPage }))
                        }}
                    // onPageSizeChange={(newPageSize) => setPageState(old => ({ ...old, pageSize: newPageSize }))}

                    />
                </Paper>

            </BodyWapperUI>



        </>
    )
}

export default UserSurveryAttempt
